import { createAction, props } from '@ngrx/store';
import { AdvancedSearchPayload } from './listings.models';
import { ExtendedBaseInterface } from '../auth/auth.models';
import {
  Amenity,
  Bookings,
  PropertyImageType,
  PropertyListing,
  PropertyStatusData,
  PropertyType,
  ToggleAvailability,
} from 'src/app/shared/models';
import { ApplicationApiUrls } from 'src/app/constants/api-url-constants';

export enum ActionTypes {
  GET_HOME_PAGE_LISTINGS = '[Listings] Get Home Page Listings',
  GET_HOME_PAGE_LISTINGS_SUCCESS = '[Listings] Get Home Page Listings Success',
  GET_HOME_PAGE_LISTINGS_FAILURE = '[Listings] Get Home Page Listings Failure',

  GET_ALL_AMENITIES = '[Listings] Get All Amenities',
  GET_ALL_AMENITIES_SUCCESS = '[Listings] Get All Amenities Success',
  GET_ALL_AMENITIES_FAILURE = '[Listings] Get All Amenities Failure',

  GET_ALL_PROPERTY_TYPES = '[Listings] Get All Property Types',
  GET_ALL_PROPERTY_TYPES_SUCCESS = '[Listings] Get All Property Types Success',
  GET_ALL_PROPERTY_TYPES_FAILURE = '[Listings] Get All Property Types Failure',

  UPLOAD_FILE = '[Listings] Upload File',
  UPLOAD_FILE_SUCCESS = '[Listings] Upload File Success',
  UPLOAD_FILE_FAILURE = '[Listings] Upload File Failure',

  CREATE_UPDATE_PROPERTY_LISTING = '[Listings] Create/Update Property Listing',
  CREATE_UPDATE_PROPERTY_LISTING_SUCCESS = '[Listings] Create/Update Property Listing Success',
  CREATE_UPDATE_PROPERTY_LISTING_FAILURE = '[Listings] Create/Update Property Listing Failure',

  GET_PROPERTY_DETAILS = '[Listings] Get Property Details',
  GET_PROPERTY_DETAILS_SUCCESS = '[Listings] Get Property Details Success',
  GET_PROPERTY_DETAILS_FAILURE = '[Listings] Get Property Details Failure',

  SET_PROPERTY_STATUS = '[Listings] Set Property Status',
  SET_PROPERTY_STATUS_SUCCESS = '[Listings] Set Property Status Success',
  SET_PROPERTY_STATUS_FAILURE = '[Listings] Set Property Status Failure',

  DELETE_PROPERTY = '[Listings] Delete Property',
  DELETE_PROPERTY_SUCCESS = '[Listings] Delete Property Success',
  DELETE_PROPERTY_FAILURE = '[Listings] Delete Property Failure',

  GET_ALL_BOOKINGS = '[Listings] Get All Bookings',
  GET_ALL_BOOKINGS_SUCCESS = '[Listings] Get All Bookings Success',
  GET_ALL_BOOKINGS_FAILURE = '[Listings] Get All Bookings Failure',

  TOGGLE_PROPERTY_AVAILABILITY = '[Listings] Toggle Property Availability',
  TOGGLE_PROPERTY_AVAILABILITY_SUCCESS = '[Listings] Toggle Property Availability Success',
  TOGGLE_PROPERTY_AVAILABILITY_FAILURE = '[Listings] Toggle Property Availability Failure',
}

export const getHomePageListings = createAction(
  ActionTypes.GET_HOME_PAGE_LISTINGS,
  props<{ data: Partial<AdvancedSearchPayload>; isLazyLoad: boolean }>(),
);

export const getHomePageListingsSuccess = createAction(
  ActionTypes.GET_HOME_PAGE_LISTINGS_SUCCESS,
  props<{ data: ExtendedBaseInterface }>(),
);

export const getHomePageListingsFailure = createAction(
  ActionTypes.GET_HOME_PAGE_LISTINGS_FAILURE,
  props<{ error: any }>(),
);

export const getAllAmenities = createAction(ActionTypes.GET_ALL_AMENITIES);

export const getAllAmenitiesSuccess = createAction(
  ActionTypes.GET_ALL_AMENITIES_SUCCESS,
  props<{ amenities: Amenity[] }>(),
);

export const getAllAmenitiesFailure = createAction(ActionTypes.GET_ALL_AMENITIES_FAILURE, props<{ error: any }>());

export const getAllPropertyTypes = createAction(ActionTypes.GET_ALL_PROPERTY_TYPES);

export const getAllPropertyTypesSuccess = createAction(
  ActionTypes.GET_ALL_PROPERTY_TYPES_SUCCESS,
  props<{ propertyTypes: PropertyType[] }>(),
);

export const getAllPropertyTypesFailure = createAction(
  ActionTypes.GET_ALL_PROPERTY_TYPES_FAILURE,
  props<{ error: any }>(),
);

export const uploadFile = createAction(ActionTypes.UPLOAD_FILE, props<{ file: File; imageType: PropertyImageType }>());

export const uploadFileSuccess = createAction(
  ActionTypes.UPLOAD_FILE_SUCCESS,
  props<{ data: any; imageType: PropertyImageType }>(),
);

export const uploadFileFailure = createAction(
  ActionTypes.UPLOAD_FILE_FAILURE,
  props<{ error: any; imageType: PropertyImageType }>(),
);

export const createUpdatePropertyListing = createAction(
  ActionTypes.CREATE_UPDATE_PROPERTY_LISTING,
  props<{ data: Partial<PropertyListing>; isDraft: boolean }>(),
);

export const createUpdatePropertyListingSuccess = createAction(
  ActionTypes.CREATE_UPDATE_PROPERTY_LISTING_SUCCESS,
  props<{ data: any }>(),
);

export const createUpdatePropertyListingFailure = createAction(
  ActionTypes.CREATE_UPDATE_PROPERTY_LISTING_FAILURE,
  props<{ error: any }>(),
);

export const getPropertyDetails = createAction(ActionTypes.GET_PROPERTY_DETAILS, props<{ propertyId: number }>());

export const getPropertyDetailsSuccess = createAction(ActionTypes.GET_PROPERTY_DETAILS_SUCCESS, props<{ data: any }>());

export const getPropertyDetailsFailure = createAction(
  ActionTypes.GET_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const setPropertyStatus = createAction(
  ActionTypes.SET_PROPERTY_STATUS,
  props<{ data: PropertyStatusData; searchData: Partial<AdvancedSearchPayload> }>(),
);

export const setPropertyStatusSuccess = createAction(ActionTypes.SET_PROPERTY_STATUS_SUCCESS, props<{ data: any }>());

export const setPropertyStatusFailure = createAction(ActionTypes.SET_PROPERTY_STATUS_FAILURE, props<{ error: any }>());

export const deleteProperty = createAction(
  ActionTypes.DELETE_PROPERTY,
  props<{ propertyId: number; searchData: Partial<AdvancedSearchPayload> }>(),
);

export const deletePropertySuccess = createAction(ActionTypes.DELETE_PROPERTY_SUCCESS, props<{ data: any }>());

export const deletePropertyFailure = createAction(ActionTypes.DELETE_PROPERTY_FAILURE, props<{ error: any }>());

export const getBookings = createAction(
  ActionTypes.GET_ALL_BOOKINGS,
  props<{ data: Bookings; url: ApplicationApiUrls }>(),
);

export const getBookingsSuccess = createAction(ActionTypes.GET_ALL_BOOKINGS_SUCCESS, props<{ data: any }>());

export const getBookingsFailure = createAction(ActionTypes.GET_ALL_BOOKINGS_FAILURE, props<{ error: any }>());

export const toggleAvailability = createAction(
  ActionTypes.TOGGLE_PROPERTY_AVAILABILITY,
  props<{ data: ToggleAvailability; searchData: Partial<AdvancedSearchPayload> }>(),
);

export const toggleAvailabilitySuccess = createAction(
  ActionTypes.TOGGLE_PROPERTY_AVAILABILITY_SUCCESS,
  props<{ data: any }>(),
);

export const toggleAvailabilityFailure = createAction(
  ActionTypes.TOGGLE_PROPERTY_AVAILABILITY_FAILURE,
  props<{ error: any }>(),
);
